import { createContext, useContext, useEffect, useMemo, useState } from "react";
import api from "@/lib/api";

const I18nContext = createContext({ lang: "en", strings: {}, t: (k, fallback) => fallback || k, setLang: () => {} });

const FALLBACK = {
  en: {
    "nav.home": "Home", "nav.pricing": "Pricing", "nav.library": "Library",
    "nav.sessions": "Sessions", "nav.courses": "Courses", "nav.blog": "Blog",
  },
};

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("sl_lang") || "en");
  const [strings, setStrings] = useState(FALLBACK.en);

  useEffect(() => {
    let active = true;
    api.get(`/i18n/${lang}`)
      .then((r) => { if (active) setStrings(r.data.strings || {}); })
      .catch(() => { if (active) setStrings(FALLBACK.en); });
    localStorage.setItem("sl_lang", lang);
    document.documentElement.lang = lang;
    return () => { active = false; };
  }, [lang]);

  const t = (key, fallback) => strings[key] || fallback || key;
  const value = useMemo(() => ({ lang, strings, t, setLang: setLangState }), [lang, strings]);
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export const useI18n = () => useContext(I18nContext);
